import { useEffect, useState } from 'react';

const ONE_SECOND_IN_MILLISECONDS = 1000;

const getSecondsUntil = (timestamp: number | null) => {
  if (!timestamp) {
    return 0;
  }

  return Math.max(0, Math.ceil((timestamp - Date.now()) / ONE_SECOND_IN_MILLISECONDS));
};

const useSecondsUntil = (timestamp: number | null) => {
  const [, setSeconds] = useState(() => getSecondsUntil(timestamp));

  useEffect(() => {
    setSeconds(getSecondsUntil(timestamp));

    if (!timestamp) {
      return undefined;
    }

    const interval = setInterval(() => {
      const remainingSeconds = getSecondsUntil(timestamp);
      setSeconds(remainingSeconds);

      if (remainingSeconds === 0) {
        clearInterval(interval);
      }
    }, ONE_SECOND_IN_MILLISECONDS);

    return () => clearInterval(interval);
  }, [timestamp]);

  return getSecondsUntil(timestamp);
};

export default useSecondsUntil;
